import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import ProgressBar from "./ProgressBar";

type ProgressBarType = typeof ProgressBar;

export default {
    title: "Progress Indicators/Progress Bar",
    component: ProgressBar,
    args: {
        value: 65
    }
} as ComponentMeta<ProgressBarType>;

const Template: ComponentStory<ProgressBarType> = args => <ProgressBar {...args} />;

export const Default = Template.bind({});

export const LabelBottom = Template.bind({});
LabelBottom.args = {
    label: "bottom"
};

export const LabelTop = Template.bind({});
LabelTop.args = {
    label: "top"
};

export const LabelRight = Template.bind({});
LabelRight.args = {
    label: "right"
};

export const LabelTooltipTop = Template.bind({});
LabelTooltipTop.args = {
    label: "tooltip-top"
};

export const Width = Template.bind({});
Width.args = {
    width: "100%"
};

export const CustomColors = Template.bind({});
CustomColors.args = {
    label: "right",
    progressColor: "success-400",
    progressBackgroundColor: "success-50",
    labelColor: "success-600"
};

export const CustomTextAndRange = Template.bind({});
CustomTextAndRange.args = {
    value: 327,
    maxValue: 500,
    label: "right",
    text: (value, _, max) => `${value}/${max}`
};

export const OutOfRange = Template.bind({});
OutOfRange.args = {
    value: -10,
    label: "right"
};
